import { render, staticRenderFns } from "./BucketAdminVideos.vue?vue&type=template&id=66452994&scoped=true&"
import script from "./BucketAdminVideos.vue?vue&type=script&lang=js&"
export * from "./BucketAdminVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66452994",
  null
  
)

export default component.exports